import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import { CreateEnrichmentData } from "../../../types/enrichment";
import { CountUp } from "../../CountUp";
import { useStyles } from "./styles";

export function Review() {
  const formik = useFormikContext<CreateEnrichmentData>();

  const styles = useStyles();

  const translateRule = useMemo(() => {
    return {
      update: "Substituir valores existentes",
      complete: "Completar campos em branco",
    };
  }, []);

  return (
    <>
      <Typography color="primary">Resumo</Typography>
      <Typography>Audiência: {formik.values.insight?.nameList}</Typography>
      <div className={styles.textCoast}>
        <Typography>Créditos consumidos: </Typography>
        <CountUp
          start={0}
          end={formik.values?.quantity}
          marginBottom={1}
          marginTop={1}
        />
      </div>

      <Typography>
        {/*@ts-ignore*/}
        Regra: {translateRule[formik.values?.rule]}
      </Typography>
    </>
  );
}
